module.exports = __webpack_public_path__ + "img/icon-capitalist.7a9aa5f2.svg";